import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';
import { UserService } from '../../../shared/user.service';
import { Folder } from 'src/app/models/folder';
import { FolderStructure } from 'src/app/models/FolderStructure';
import { CreateFolderRequest } from 'src/app/models/CreateFolderRequest';

@Component({
  selector: 'app-manage-folder-structure',
  templateUrl: './manage-folder-structure.component.html',
  styleUrls: ['./manage-folder-structure.component.css']
})
export class ManageFolderStructureComponent implements OnInit {
  isModify = false;
  isModification = false;
  isModificationError = false;
  businessStructure: Folder;
  productFamily: Folder;
  product: Folder;
  configuration: Folder;
  businessStructureSearch: Folder;
  productFamilySearch: Folder;
  productSearch: Folder;
  configurationSearch: Folder;
  showProductFamily = false;
  showProduct = false;
  showConfiguartion = false;
  showBusiness = false;
  parentFolder: Folder;
  isFolderCreation = false;
  folderName = '';
  deletedFolder = false;
  previousBusinessArray: Array<FolderStructure> = [];
  previousProductFamilyArray: Array<FolderStructure> = [];
  previousProductArray: Array<FolderStructure> = [];
  previousConfigurationArray: Array<FolderStructure> = [];
  rename = false;
  folderNameError = false;
  folderNameRegex = new RegExp('^[a-zA-Z0-9-_ ]+$');
  folderNameFlag: boolean;
  folderNameExists = false;
  searchKeyBusiness = '';
  searchKeyProductFamily = '';
  searchKeyProduct = '';
  searchKeyConfiguration = '';
  searchBusinessFlag = false;
  searchProductFamilyFlag = false;
  searchProductFlag = false;
  searchConfigurationFlag = false;
  deletedFolderDetails: Folder;
  modifiedFolderDetails: Folder;
  deletedError = '';
  deletedErrorflag = false;
  modalType = '';
  selectedBUnit: Folder;
  preview: any;
  supportedImageFormats = ['jpg', 'jpeg', 'png', 'tiff', 'gif', 'bmp'];
  previewImage = [];
  theme_color: string;

  constructor(private _httpService: HttpService, private _userService: UserService) { }

  ngOnInit() {
    let User = JSON.parse(sessionStorage.getItem('userinfo'));
    this.theme_color = User.userSettings.userThemeType===0?'dark':'light';
    this.showBusiness = false;
    this.getBusinessStructure();
  }
  getBusinessStructure() {
    this.showBusiness = true;
    this._httpService.getRootFolderData(this._userService.loggendInUser.userEmailId).subscribe(
      data => {
        this.businessStructure = data[0];
        this.businessStructure.subFolders.forEach(fol => fol.parentId = this.businessStructure._id);
        this.parentFolder = this.businessStructure;
      });
  }
  getProductFamilyFolders(parentFolder: FolderStructure) {
    if (parentFolder.selected === undefined) {
      parentFolder.selected = false;
    }
    parentFolder.selected = !parentFolder.selected;
    this.previousBusinessArray.push(parentFolder);
    this.previousBusinessArray.forEach(folder => {
      if (folder._id !== parentFolder._id) {
        folder.selected = false;
        if (this.searchBusinessFlag) {
          this.businessStructureSearch.subFolders.map(sub => {
            if (sub._id !== parentFolder._id) {
              sub.selected = false;
            }
          });
          this.businessStructure.subFolders.map(sub => {
            if (sub._id === parentFolder._id) {
              sub.selected = true;
            }
          });
        }
      }
    });

    if (parentFolder.selected) {

      this.showProductFamily = true;
      this.showProduct = false;
      this.showConfiguartion = false;
      this._httpService.getFolderById(parentFolder._id).subscribe(
        data => {
          this.productFamily = data;
          this.parentFolder = this.productFamily;
          this.productFamily.subFolders.forEach(sub => sub.parentId = this.productFamily._id);
          this.selectedBUnit = this.productFamily;
        }
      );
    } else {
      this.showProductFamily = false;
      this.showProduct = false;
      this.showConfiguartion = false;
    }

    this.searchProductFamilyFlag = false;
    this.searchProductFlag = false;
    this.searchConfigurationFlag = false;
    this.searchKeyProductFamily = '';
    this.searchKeyProduct = '';
    this.searchKeyConfiguration = '';
  }
  getProductFolders(parentFolder: FolderStructure) {
    if (parentFolder.selected === undefined) {
      parentFolder.selected = false;
    }
    parentFolder.selected = !parentFolder.selected;
    this.previousProductFamilyArray.push(parentFolder);
    this.previousProductFamilyArray.forEach(folder => {
      if (folder._id !== parentFolder._id) {
        folder.selected = false;
        if (this.searchProductFamilyFlag) {
          this.productFamilySearch.subFolders.map(sub => {
            if (sub._id !== parentFolder._id) {
              sub.selected = false;
            }
          });
          this.productFamily.subFolders.map(sub => {
            if (sub._id === parentFolder._id) {
              sub.selected = true;
            }
          });
        }
      }
    });
    if (parentFolder.selected) {
      this.showProduct = true;
      this.showConfiguartion = false;
      this._httpService.getFolderById(parentFolder._id).subscribe(
        data => {
          this.product = data;
          this.parentFolder = this.product;
          this.product.subFolders.forEach(sub => sub.parentId = this.product._id);
        }
      );
    } else {
      this.showProduct = false;
      this.showConfiguartion = false;
    }
    this.searchProductFlag = false;
    this.searchKeyProduct = '';
    this.searchConfigurationFlag = false;
    this.searchKeyConfiguration = '';
  }
  getConfiguarionFolders(parentFolder: FolderStructure) {
    if (parentFolder.selected === undefined) {
      parentFolder.selected = false;
    }
    parentFolder.selected = !parentFolder.selected;
    this.previousProductArray.push(parentFolder);
    this.previousProductArray.forEach(folder => {
      if (folder._id !== parentFolder._id) {
        folder.selected = false;
        if (this.searchProductFlag) {
          this.productSearch.subFolders.map(sub => {
            if (sub._id !== parentFolder._id) {
              sub.selected = false;
            }
          });
          this.product.subFolders.map(sub => {
            if (sub._id === parentFolder._id) {
              sub.selected = true;
            }
          });
        }
      }
    });
    if (parentFolder.selected) {
      this.showConfiguartion = true;
      this._httpService.getFolderById(parentFolder._id).subscribe(
        data => {
          this.configuration = data;
          this.parentFolder = this.configuration;
          this.configuration.subFolders.forEach(fol => fol.parentId = this.configuration._id);
        }
      );
    } else {
      this.showConfiguartion = false;
    }
    this.searchConfigurationFlag = false;
    this.searchKeyConfiguration = '';
  }
  getConfiguration(fold: FolderStructure) {
    fold.selected = !fold.selected;
    this.previousConfigurationArray.push(fold);
    this.previousConfigurationArray.forEach(folder => {
      if (folder._id !== fold._id) {
        folder.selected = false;
      }
    });
  }
  createBusinessStructure(folderGroup: string) {
    this.folderName = '';
    this.isModification = false;
    this.isModificationError = false;
    this.isFolderCreation = false;
    this.isModify = false;
    this.isFolderCreation = false;
    this.folderNameError = false;
    this.folderNameExists = false;
    document.getElementById('folderCreationModal').setAttribute('label', 'Create Folder');
    document.getElementById('folderCreationModal').setAttribute('visible', 'true');
    document.getElementById('newFolderName2').setAttribute('name', folderGroup);
  }

  createFolderApi(folder: CreateFolderRequest, folderGroup: string) {
    this._httpService.createFolder(folder, this._userService.loggendInUser.userEmailId).subscribe(
      data => {
        this.isFolderCreation = true;
        this.folderNameExists = false;
        this.folderNameError = false;
        const folderCreated: Folder = data;
        folderCreated.parentId = folder.parentId;
        this.getFolder(folderCreated, folderGroup);
        document.getElementById('folderCreationModal').setAttribute('visible', 'false');
        this.folderName = '';
      }, error => {
        // Checking if actual error massage coming from API, Then show appropriate massage to user

        if (error.error === 'Folder already exists.') {
          this.folderNameExists = true;
        }
        else {
          console.log('Error');
        }

      });
  }


  folderCreation() {
    const folderGroup = document.getElementById('newFolderName2').getAttribute('name');
    const folder = new CreateFolderRequest(this.folderName);
    switch (folderGroup) {
      case 'Business':
        folder.relativePath = this.folderName;
        folder.parentId = this.businessStructure._id;
        this._httpService.folder = this.businessStructure;
        break;
      case 'ProductFamily':
        const parentFolder = this.previousBusinessArray.filter(fol => fol.selected === true)[0];
        folder.relativePath = parentFolder.realativePath + ',' + folder.name;
        folder.parentId = parentFolder._id;
        this._httpService.folder = this.productFamily;
        break;
      case 'Product':
        const parentFolderProduct = this.previousProductFamilyArray.filter(fol => fol.selected === true)[0];
        folder.relativePath = parentFolderProduct.realativePath + ',' + folder.name;
        folder.parentId = parentFolderProduct._id;
        this._httpService.folder = this.product;
        break;
      case 'Configuration':
        const parentFolderConfiguration = this.previousProductArray.filter(fol => fol.selected === true)[0];
        folder.relativePath = parentFolderConfiguration.realativePath + ',' + folder.name;
        folder.parentId = parentFolderConfiguration._id;
        this._httpService.folder = this.configuration;
        break;
    }
    const sameNameFolder = this._httpService.folder.subFolders.filter(
      foldersub => foldersub.name.toLowerCase() === this.folderName.toLowerCase()
    );
    if (sameNameFolder.length === 0) {
      this.createFolderApi(folder, folderGroup);
    } else {
      this.folderNameError = false;
      this.folderNameExists = true;
    }
  }

  getFolder(folder: Folder, folderGroup: string) {
    switch (folderGroup) {
      case 'Business':
        this.businessStructure.subFolders.push(folder);
        break;
      case 'ProductFamily':
        this.productFamily.subFolders.push(folder);
        break;
      case 'Product':
        this.product.subFolders.push(folder);
        break;
      case 'Configuration':
        this.configuration.subFolders.push(folder);
        break;
    }
  }


  deleteBusinessStructure(folder: Folder, folderType: string) {
    this.modalType = '';
    this.deletedErrorflag = false;
    this.deletedFolder = false;
    this.deletedError = '';
    document.getElementById('folderDeletionModal').setAttribute('visible', 'true');
    document.querySelector('#folderDeletionModal').setAttribute('name', folderType);
    this.deletedFolderDetails = folder;
  }
  folderDeletion() {
    const deleteFolder = {
      folderId: this.deletedFolderDetails._id,
      parentId: this.deletedFolderDetails.parentId,
      userEmailId: this._userService.loggendInUser.userEmailId
    };
    this._httpService.deleteFolder(deleteFolder).subscribe(data => {
      this.deleteFolder(this.deletedFolderDetails._id);
      this.deletedFolder = true;
      this.deletedErrorflag = false;
      this.modalType = 'confirmation';
      this.deletedError = '';
    }, error => {
      console.log(error);
      this.deletedFolder = false;
      this.deletedErrorflag = true;
      this.deletedError = error.error.data ? error.error.data : error.error;
      this.modalType = 'error';
    });
    document.getElementById('folderDeletionModal').setAttribute('visible', 'false');
  }
  deleteFolder(folderId: string) {
    const folderType = document.querySelector('#folderDeletionModal').getAttribute('name');
    switch (folderType) {
      case 'Business':
        this.businessStructure.subFolders = this.businessStructure.subFolders.filter(fol => fol._id !== folderId);
        if (this.searchBusinessFlag) {
          this.businessStructureSearch.subFolders = this.businessStructureSearch.subFolders.filter(fol => fol._id !== folderId);
        }
        this.showProductFamily = false;
        this.showProduct = false;
        this.showConfiguartion = false;
        break;
      case 'ProductFamily':
        this.productFamily.subFolders = this.productFamily.subFolders.filter(fol => fol._id !== folderId);
        if (this.searchProductFamilyFlag) {
          this.productFamilySearch.subFolders = this.productFamilySearch.subFolders.filter(fol => fol._id !== folderId);
        }
        this.showProduct = false;
        this.showConfiguartion = false;
        break;
      case 'Product':
        this.product.subFolders = this.product.subFolders.filter(fol => fol._id !== folderId);
        if (this.searchProductFlag) {
          this.productSearch.subFolders = this.productSearch.subFolders.filter(fol => fol._id !== folderId);
        }
        this.showConfiguartion = false;
        break;
      case 'Configuration':
        if (this.searchConfigurationFlag) {
          this.configurationSearch.subFolders = this.configurationSearch.subFolders.filter(fol => fol._id !== folderId);
        }
        this.configuration.subFolders = this.configuration.subFolders.filter(fol => fol._id !== folderId);
        break;

    }
  }
  folderNameValidation(str: string) {
    if (this.folderNameRegex.test(str) &&
      (!str.endsWith('-') && !str.endsWith('_')) &&
      (str.slice(0, 1) !== '_' && str.slice(0, 1) !== '-')) {
      this.folderNameFlag = true;
    } else {
      this.folderNameFlag = false;
      this.folderNameError = false;
      this.folderNameExists = false;
    }
  }

  addNewFolder() {
    if (!this.folderNameFlag) {
      return;
    }
    if (this.folderName === '' || this.folderName.trim() === '') {
      this.folderNameError = true;
      this.folderNameExists = false;
    } else if (this.isModify) {
      this.modifyFolderApi();
    } else {
      this.folderCreation();
    }
  }
  modifyFolder(data: Folder) {
    const folderGroup = document.getElementById('newFolderName2').getAttribute('name');
    switch (folderGroup) {
      case 'Business':
        this.showConfiguartion = false;
        this.showProduct = false;
        this.showProductFamily = false;
        this.searchBusinessFlag = false;
        this.searchKeyBusiness = '';
        this.searchKeyConfiguration = '';
        this.searchKeyProduct = '';
        this.searchKeyProductFamily = '';
        this.searchProductFamilyFlag = false;
        this.searchProductFlag = false;
        this.searchConfigurationFlag = false;
        this.getBusinessStructure();
        break;
      case 'ProductFamily':
        this.showProduct = false;
        this.showConfiguartion = false;
        this.searchKeyConfiguration = '';
        this.searchKeyProduct = '';
        this.searchKeyProductFamily = '';
        this.searchProductFamilyFlag = false;
        this.searchProductFlag = false;
        this.searchConfigurationFlag = false;
        const indexPr = this.productFamily.subFolders.indexOf(this.modifiedFolderDetails);
        data.parentId = this.productFamily.subFolders[indexPr].parentId;
        this.productFamily.subFolders[indexPr] = data;
        break;
      case 'Product':
        this.showConfiguartion = false;
        this.searchKeyConfiguration = '';
        this.searchKeyProduct = '';
        this.searchProductFlag = false;
        this.searchConfigurationFlag = false;
        const indexConfig = this.product.subFolders.indexOf(this.modifiedFolderDetails);
        data.parentId = this.product.subFolders[indexConfig].parentId;
        this.product.subFolders[indexConfig] = data;
        break;
      case 'Configuration':
        this.searchKeyConfiguration = '';
        this.searchConfigurationFlag = false;
        const index = this.configuration.subFolders.indexOf(this.modifiedFolderDetails);
        data.parentId = this.configuration.subFolders[index].parentId;
        this.configuration.subFolders[index] = data;
        break;
    }
  }

  modifyFolderApi() {
    if (!this.sameNameValidationForModify()) {
      const folderData = {
        NewFolderName: this.folderName,
        FolderId: this.modifiedFolderDetails._id,
        ParentFolderId: this.modifiedFolderDetails.parentId
      };
      this._httpService.modifyFolder(folderData, this._userService.loggendInUser.userEmailId).subscribe(data => {
        this.isModificationError = false;
        this.modifyFolder(data);
        this.isModification = true;
      }, error => {
        this.isModification = false;
        this.isModificationError = true;
        console.log(error);
      });
    }
  }

  sameNameValidationForModify() {
    const folderGroup = document.getElementById('newFolderName2').getAttribute('name');
    switch (folderGroup) {
      case 'Business':
        const fold = this.businessStructure.subFolders.find(s => s.name === this.folderName);
        if (fold != null) {
          this.folderNameError = false;
          this.folderNameExists = true;
          return true;
        }
        break;
      case 'ProductFamily':
        const prod = this.productFamily.subFolders.find(s => s.name === this.folderName);
        if (prod != null) {
          this.folderNameError = false;
          this.folderNameExists = true;
          return true;
        }
        break;
      case 'Product':
        const folder = this.product.subFolders.find(s => s.name === this.folderName);
        if (folder != null) {
          this.folderNameError = false;
          this.folderNameExists = true;
          return true;
        }
        break;
      case 'Configuration':
        const config = this.configuration.subFolders.find(s => s.name === this.folderName);
        if (config != null) {
          this.folderNameError = false;
          this.folderNameExists = true;
          return true;
        }
        break;
    }
  }
  removeFolder() {
    this.rename = false;
  }

  searchBusiness(event: KeyboardEvent) {
    this.searchKeyBusiness = event.target['value'];

    if (!this.searchKeyBusiness || this.searchKeyBusiness.trim() === '') {
      this.searchBusinessFlag = false;
      this.getBusinessStructure();
      return;
    }
    this.businessStructure.subFolders.forEach(business => {
      if ((business.name.toLowerCase()).includes(this.searchKeyBusiness.toLowerCase())) {
        // tslint:disable-next-line: max-line-length
        this.businessStructureSearch = JSON.parse(JSON.stringify(this.businessStructure));
        this.businessStructureSearch.subFolders = this.businessStructureSearch.subFolders.filter(sub => (sub.name.toLowerCase()).includes(this.searchKeyBusiness.toLowerCase()));
        this.searchBusinessFlag = true;
      }
    });
  }

  reset() {
    this.searchBusinessFlag = false;
  }

  searchProduct(event: KeyboardEvent) {
    this.searchKeyProduct = event.target['value'];

    if (!this.searchKeyProduct || this.searchKeyProduct.trim() === '') {
      this.resetProduct();
      return;
    }
    this.product.subFolders.forEach(product => {
      if ((product.name.toLowerCase()).includes(this.searchKeyProduct.toLowerCase())) {
        // tslint:disable-next-line: max-line-length
        this.productSearch = JSON.parse(JSON.stringify(this.product));
        this.productSearch.subFolders = this.productSearch.subFolders.filter(sub => (sub.name.toLowerCase()).includes(this.searchKeyProduct.toLowerCase()));
        this.searchProductFlag = true;
      }
    });
  }

  resetProduct() {
    this.searchProductFlag = false;
  }

  searchConfiguration(event: KeyboardEvent) {
    this.searchKeyConfiguration = event.target['value'];

    if (!this.searchKeyConfiguration || this.searchKeyConfiguration.trim() === '') {
      this.resetConfiguration();
      return;
    }
    this.configuration.subFolders.forEach(conf => {
      if ((conf.name.toLowerCase()).includes(this.searchKeyConfiguration.toLowerCase())) {
        // tslint:disable-next-line: max-line-length
        this.configurationSearch = JSON.parse(JSON.stringify(this.configuration));
        this.configurationSearch.subFolders = this.configurationSearch.subFolders.filter(sub => (sub.name.toLowerCase()).includes(this.searchKeyConfiguration.toLowerCase()));
        this.searchConfigurationFlag = true;
      }
    });

  }

  resetConfiguration() {
    this.searchConfigurationFlag = false;
  }

  searchProductFamily(event: KeyboardEvent) {
    this.searchKeyProductFamily = event.target['value'];
    if (!this.searchKeyProductFamily || this.searchKeyProductFamily.trim() === '') {
      this.resetProductFamily();
      return;
    }
    this.productFamily.subFolders.forEach(product => {
      if ((product.name.toLowerCase()).includes(this.searchKeyProductFamily.toLowerCase())) {
        // tslint:disable-next-line: max-line-length
        this.productFamilySearch = JSON.parse(JSON.stringify(this.productFamily));
        this.productFamilySearch.subFolders = this.productFamilySearch.subFolders.filter(sub => sub.name.toLowerCase().includes(this.searchKeyProductFamily.toLowerCase()));
        this.searchProductFamilyFlag = true;
      }
    });
  }

  resetProductFamily() {
    this.searchProductFamilyFlag = false;
  }
  editFolder(folderGroup: string, folder: Folder) {
    this.folderName = '';
    this.isFolderCreation = false;
    this.isModification = false;
    this.isModificationError = false;
    this.isModify = true;
    this.isFolderCreation = false;
    this.folderNameError = false;
    this.folderName = '';
    this.folderNameExists = false;
    document.getElementById('folderCreationModal').setAttribute('label', 'Rename Folder');
    document.getElementById('folderCreationModal').setAttribute('visible', 'true');
    document.getElementById('newFolderName2').setAttribute('name', folderGroup);
    this.modifiedFolderDetails = folder;
  }

  displayImage() {
    this.preview = 'assets/DefaultImages/' + this.selectedBUnit.displayImage;
    document.getElementById('displayImageModal').setAttribute('visible', 'true');
  }

  openBrowseWindow() {
    document.getElementById('browseFile').click();
  }

  selectPreviewImage(event) {
    // let minWidth: number = 400;
    // let minHeight: number = 400;
    let minWidth: number = 1280;
    let minHeight: number = 1024;
    let maxSize: number = 2097152;
    let previewImage: FileList = event.target.files;

    if (previewImage.length > 0) {
      for (let i = 0; i < previewImage.length; i++) {

        if (this.supportedImageFormats.indexOf(previewImage[i].name.split('.')[previewImage[i].name.split('.').length - 1].toLowerCase()) == -1
          || previewImage[i].size > maxSize) {
          alert("Please upload image(less than 2MB) with image resolution of 400 x 400 px or lower.");
          return true;
        }
        let reader = new FileReader();

        reader.onload = (e: any) => {
          const img = new Image();
          img.src = e.target.result;
          img.onload = rs => {

            if (img.height > minHeight || img.width > minWidth) {
              alert("Please upload image(less than 2MB) with image resolution of 400 x 400 px or lower.");
              return true;
            }
            else {
              this.previewImage.push(previewImage[i]);
              this.preview = e.target.result;
            }

          }
        }
        reader.readAsDataURL(previewImage[i]);
      }
    }
  }

  addDisplayImage() {
    const formData = new FormData();
    if (this.previewImage && this.previewImage.length > 0) {
      for (let i = 0; i < this.previewImage.length; i++) {
        formData.append('displayImage', this.previewImage[i], this.previewImage[i].name);
      }
    }
    this._httpService.addBusinessUnitImage(this.selectedBUnit._id, this._userService.loggendInUser.userEmailId, formData).subscribe((res: any) => {
      alert(res);
    },
    (err) => {
      alert("error occurred");
    },
    () => {
      this.previewImage = [];
    });
  }
}

